<span class="badge badge-pedido-status badge-pedido-status-confirmado">
    {{status.nome}}
</span>